export default __webpack_public_path__ + "static/media/title1.75077e02.png";